import api, { adminApiPrefix } from './Api';
import {
  Blog,
  blogFromResponse,
  blogToUpsertRequest,
} from '../interfaces/Blog/Blog';
import { BlogMediaOptions } from '../interfaces/Blog/BlogMediaOptions';
import { base64ToFile } from '../utils/Encoding';

const blogAdminApiPrefix = `${adminApiPrefix}/blogs`;

export const createBlog = async (blog: Blog): Promise<Blog> => {
  const response = await api.post(
    `${blogAdminApiPrefix}/`,
    blogToUpsertRequest(blog),
  );

  return blogFromResponse(response.data?.data);
};

export const getBlogs = async (): Promise<Blog[]> => {
  const response = await api.get(blogAdminApiPrefix);

  return (response.data?.data ?? []).map((blog: any) => blogFromResponse(blog));
};

export const getBlog = async (slug: string): Promise<Blog> => {
  const response = await api.get(`${blogAdminApiPrefix}/${slug}`);

  return blogFromResponse(response.data?.data);
};

export const generateCoverImage = async (
  blog: Blog,
  additionalPrompt: string,
): Promise<File | undefined> => {
  const response = await api.post(`${blogAdminApiPrefix}/cover-image`, {
    ...blogToUpsertRequest(blog),
    additional_prompt: additionalPrompt,
  });

  const bytes = response.data?.data as string;
  if (!bytes) return undefined;

  return base64ToFile(bytes, 'blog-cover.png');
};

export const updateBlog = async (blog: Blog): Promise<Blog> => {
  const response = await api.put(
    `${blogAdminApiPrefix}/${blog.id}`,
    blogToUpsertRequest(blog),
  );

  return blogFromResponse(response.data?.data);
};

export const updateBlogMedia = async (
  id: number,
  options: BlogMediaOptions,
): Promise<Blog> => {
  const bodyFormData = new FormData();

  if (options.coverImage) {
    bodyFormData.append('cover-image', options.coverImage);
  }

  if (options.eraseCoverImage) {
    bodyFormData.append('erase-cover-image', '1');
  }

  const response = await api.put(
    `${blogAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return blogFromResponse(response.data?.data);
};

export const deleteBlog = async (id: number): Promise<void> =>
  api.delete(`${blogAdminApiPrefix}/${id}`);
